<app-login-with-qr *ngIf="english"></app-login-with-qr>
<app-login-with-qr-hindi *ngIf="hindi"></app-login-with-qr-hindi>